export default __webpack_public_path__ + "static/cube-c949d00d7e72a219ef96ef6bd8988bbf.mp4";